import Swiper, {Navigation, Pagination} from "swiper";
import {sliderNavigation, sliderPagination} from "../../helpers/slider-modules-create";
document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.read-interesting__swiper')
  const pagination = document.querySelector('.read-interesting__pagination')
  if(slider) {
    new Swiper(slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: false,
      pagination: sliderPagination(pagination),
      navigation: sliderNavigation('read-interesting__navigation')
    })
  }
})
